import React from 'react'

import withDefaultStyles from './withDefaultStyles'

const FillAdvancedTwitter = ({ fill = 'currentColor' }) => (
  <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
    <g clip-path="url(#clip0_31164_119)">
      <mask
        id="mask0_31164_119"
        style={{ maskType: 'luminance' }}
        maskUnits="userSpaceOnUse"
        x="0"
        y="0"
        width="24"
        height="24"
      >
        <path d="M24 0H0V24H24V0Z" fill="white" />
      </mask>
      <g mask="url(#mask0_31164_119)">
        <path
          fill-rule="evenodd"
          clip-rule="evenodd"
          d="M7 2H17C19.76 2 22 4.24 22 7V17.01C22 19.77 19.76 22 17 22H7C4.24 22 2 19.76 2 17V7C2 4.24 4.24 2 7 2ZM6.5 6.90856C6.62822 6.65779 6.88613 6.5 7.16777 6.5H9.94555C10.1863 6.5 10.4125 6.61565 10.5535 6.81088L13.0666 10.2905L16.6375 6.71967C16.9304 6.42678 17.4052 6.42678 17.6981 6.71967C17.9909 7.01256 17.9909 7.48744 17.6981 7.78033L13.9563 11.5222L17.7758 16.8109C17.9407 17.0392 17.9638 17.3407 17.8356 17.5914C17.7074 17.8422 17.4495 18 17.1678 18H14.3899C14.1491 18 13.9229 17.8844 13.7819 17.6891L11.269 14.2095L7.69811 17.7803C7.40521 18.0732 6.93034 18.0732 6.63745 17.7803C6.34455 17.4874 6.34455 17.0126 6.63745 16.7197L10.3794 12.9778L6.55977 7.68912C6.39486 7.46079 6.37178 7.15933 6.5 6.90856Z"
          fill={fill}
        />
      </g>
    </g>
    <defs>
      <clipPath id="clip0_31164_119">
        <rect width="24" height="24" fill="white" />
      </clipPath>
    </defs>
  </svg>
)

export default withDefaultStyles(FillAdvancedTwitter)
